import { actions } from 'react-redux-toastr'

export const errorMessageAdd = (message) =>
  actions.add({
    type: 'error',
    message,
    options: {
      removeOnHover: true
    }
  })

export const successMessageAdd = (message) =>
actions.add({
  type: 'success',
  message,
  options: {
    removeOnHover: true
  }
})



// WEBPACK FOOTER //
// ./src/store/toasts.js